import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => <FormattedMessage id="account.login" defaultMessage="Log in" />;
